import { render, staticRenderFns } from "./DetailsLPItems.vue?vue&type=template&id=a43e1a08&"
import script from "./DetailsLPItems.vue?vue&type=script&lang=js&"
export * from "./DetailsLPItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports